import * as Materialize from 'angular2-materialize/dist/index';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { Component, Output, EventEmitter } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import * as globals from '../globals';
import { AuthHttp, AuthConfig } from 'angular2-jwt';


// If you change any of this code, please replicate the changes in the Create Customer code at the bottom of createproject.component.ts

@Component({
    selector: 'create-customer',
    templateUrl: './createcustomer.component.html',
    styleUrls: ['./createcustomer.component.css']
  })
export class CreateCustomerComponent {

    private customerurl = globals.APIURL + '/customer';

    companyname: string;
    addressone: string;
    addresstwo: string;
    companycity: string;
    companystate: string;
    companyzip: string;
    companycountry: string;
    companyphone: string;
    companyfax: string;
    companyurl: string;
    primarycontactfirstname: string;
    primarycontactlastname: string;
    primarycontactemail: string;
    primarycontactphone: string;
    accountowner: string;
    requiredfieldEmpty: boolean = true;
    ownerselect: number;
    planid: string;
    waiticon: string;
    ownerArray: any = [];

    @Output() AddCustomerCompleteAction = new EventEmitter();
    modalNewAccountAction = new EventEmitter<string | MaterializeAction>();

    constructor(private http: Http, public authHttp: AuthHttp) { }

    openModalNewAccount(ownerArray: any) {
        this.ownerArray = ownerArray;
        this.modalNewAccountAction.emit({ action: 'modal', params: ['open'] });
      }

    createCustomer() {
        console.log(' Customer name : ' + this.companyname + ' first contact : ' + this.primarycontactfirstname + ' Second Contact : ' + this.primarycontactlastname);
        if (this.requiredfieldEmpty) {
        Materialize.toast('Company Name, Priamary Contact name & Account owner fields are required!', 4000);
        return;
        }
        this.waiticon = 'fa right fa-spinner fa-pulse';
        (<HTMLInputElement>document.getElementById('CreateNewCustomer')).disabled = true;

        let rating = Number((<HTMLInputElement>document.getElementById('newcustomerrating')).value);
        this.planid = localStorage.getItem('mr_planid');

        let customerdetails = {
        companyname: this.companyname,
        addressone: this.addressone,
        addresstwo: this.addresstwo,
        companycity: this.companycity,
        companystate: this.companystate,
        companyzip: this.companyzip,
        companycountry: this.companycountry,
        companyphone: this.companyphone,
        companyfax: this.companyfax,
        companyurl: this.companyurl,
        primarycontactfirstname: this.primarycontactfirstname,
        primarycontactlastname: this.primarycontactlastname,
        primarycontactemail: this.primarycontactemail,
        primarycontactphone: this.primarycontactphone,
        accountowner: this.accountowner,
        owner_id: this.ownerselect,
        rating: rating,
        planid: this.planid
        };

        this.addCustomer(customerdetails)
        .subscribe(
        data => {
            console.log('customer data : ', data);
            this.waiticon = '';
            (<HTMLInputElement>document.getElementById('CreateNewCustomer')).disabled = false;
            Materialize.toast('NEW CUSTOMER CREATED SUCCESSFULLY', 2000);
            this.modalNewAccountAction.emit({ action: 'modal', params: ['close'] });
            this.AddCustomerCompleteAction.emit();
        },
        error => {
            this.waiticon = '';
            this.modalNewAccountAction.emit({ action: 'modal', params: ['close'] });
            (<HTMLInputElement>document.getElementById('CreateNewCustomer')).disabled = false;
        }
        );
    }

    checkEmptyField() {
        if (this.companyname && this.primarycontactfirstname && this.primarycontactlastname) {
          this.requiredfieldEmpty = false;
        } else {
          this.requiredfieldEmpty = true;
        }
    }

    onOwnerChange(value) {
        console.log('owner value', value);
        this.ownerselect = value;
    }

    addCustomer(customerdetails: any): Observable<string> {
        console.log('get users service called');

         let body;
        if (customerdetails.planid == 1) {
          body = JSON.stringify({ customer: { name: customerdetails.name } });
        } else {
          body = JSON.stringify({ customer: {
              name: customerdetails.companyname,
              address: customerdetails.addressone,
              address2: customerdetails.addresstwo,
              city: customerdetails.companycity,
              state: customerdetails.companystate,
              zip: customerdetails.companyzip,
              country: customerdetails.companycountry,
              phone: customerdetails.companyphone,
              fax: customerdetails.companyfax,
              email: customerdetails.primarycontactemail,
              website: customerdetails.companyurl,
              comments: customerdetails.comments,
              rating: customerdetails.rating,
              owner_id: customerdetails.owner_id,
            },
            primarycontact: {
                firstname: customerdetails.primarycontactfirstname,
                lastname: customerdetails.primarycontactlastname,
                phone: customerdetails.primarycontactphone,
                email: customerdetails.primarycontactemail,
                title: customerdetails.title
            }
          });
        }

        let headers = new Headers({
          'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ headers: headers });

        console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.customerurl);
        return this.authHttp.post(this.customerurl, body, options)
          .map(this.extractData)
          .catch(this.handleError);
    }

    private extractData(res: Response) {
    let body = res.json();
    console.log('BODY:', body);
    return body || {};
    }

    handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/createcustomer/createcustomer.component.ts